"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MarkdownViewContextValue = exports.Markdown = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactView = require("@catalytic/react-view");
var _viewUtilFromJsonCatalyticWeb = require("@catalytic/view-util-from-json-catalytic-web");
var _viewUtilFromMarkdown = require("@catalytic/view-util-from-markdown");
var _BaseText = _interopRequireDefault(require("./BaseText"));
var _Code = _interopRequireDefault(require("./Code"));
var _CodeSpan = _interopRequireDefault(require("./CodeSpan"));
var _Embolden = _interopRequireDefault(require("./Embolden"));
var _Heading = _interopRequireDefault(require("./Heading"));
var _Image = _interopRequireDefault(require("./Image"));
var _Link = _interopRequireDefault(require("./Link"));
var _List = _interopRequireDefault(require("./List"));
var _ListItem = _interopRequireDefault(require("./ListItem"));
var _Rule = _interopRequireDefault(require("./Rule"));
var _Table = _interopRequireDefault(require("./Table"));
var _TableCell = _interopRequireDefault(require("./TableCell"));
var _TableRow = _interopRequireDefault(require("./TableRow"));
var _sanitizer = _interopRequireDefault(require("../utils/sanitizer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import { type ViewMap } from '@catalytic/react-view';*/ /*:: import { type JSONValue } from '@catalytic/json-schema-validator-catalytic-web';*/ /*:: import { type ViewReferenceMap } from '@catalytic/view-util-from-markdown';*/
var DISPLAY_NAME = 'Markdown';
/*:: type Props = {
  /**
   * The string to be parsed
   *-/
  context?: JSONValue,
  /**
   * Remove dangerous HTML
   *-/
  sanitizeMarkdown?: boolean,
  /**
   * Remove Markdown formatting
   *-/
  stripMarkdown?: boolean,
  /**
   * The string to be parsed
   *-/
  value?: string,
  /**
   * Map of JSON pointer data for a view
   *-/
  views?: ViewReferenceMap,

  /**
   * Custom view map
   *-/
  map?: ViewMap
};*/
var VIEW_MAP /*: ViewMap*/ = (({
  blockquote: function blockquote(_ref /*:: */) {
    var children = _ref /*:: */.children;
    return /*#__PURE__*/_react.default.createElement("blockquote", null, children());
  },
  break: function _break() {
    return /*#__PURE__*/_react.default.createElement("br", null);
  },
  code: function code(_ref2 /*:: */) {
    var value = _ref2 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_Code.default, null, value);
  },
  dateView: function dateView(_ref3 /*:: */) {
    var node = _ref3 /*:: */.node,
      value = _ref3 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, (0, _extends2.default)({}, node(), {
      value: Date.parse(value)
    }));
  },
  dateTimeView: function dateTimeView(_ref4 /*:: */) {
    var node = _ref4 /*:: */.node,
      value = _ref4 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, (0, _extends2.default)({}, node(), {
      value: Date.parse(value)
    }));
  },
  definition: function definition() {
    return /*#__PURE__*/_react.default.createElement("span", null);
  },
  delete: function _delete(_ref5 /*:: */) {
    var children = _ref5 /*:: */.children;
    return /*#__PURE__*/_react.default.createElement("del", null, children());
  },
  emailView: function emailView(_ref6 /*:: */) {
    var value = _ref6 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_Link.default, {
      url: "mailto:".concat(value)
    }, value);
  },
  emphasis: function emphasis(_ref7 /*:: */) {
    var children = _ref7 /*:: */.children;
    return /*#__PURE__*/_react.default.createElement("em", null, children());
  },
  heading: function heading(_ref8 /*:: */) {
    var children = _ref8 /*:: */.children,
      node = _ref8 /*:: */.node;
    return /*#__PURE__*/_react.default.createElement(_Heading.default, {
      depth: node().depth
    }, children());
  },
  html: function html(_ref9 /*:: */) {
    var value = _ref9 /*:: */.value;
    return typeof value === 'string' ?
    /*#__PURE__*/
    // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
    _react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: (0, _sanitizer.default)(value)
      }
    }) : /*#__PURE__*/_react.default.createElement("span", null, value);
  },
  image: function image(_ref0 /*:: */) {
    var node = _ref0 /*:: */.node,
      value = _ref0 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_Image.default, {
      alt: node().alt,
      title: node().title,
      url: node().url
    }, value);
  },
  inlineCode: function inlineCode(_ref1 /*:: */) {
    var value = _ref1 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_CodeSpan.default, null, value);
  },
  integerView: function integerView(_ref10 /*:: */) {
    var node = _ref10 /*:: */.node,
      value = _ref10 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement("span", null, value.toLocaleString(undefined, node()));
  },
  link: function link(_ref11 /*:: */) {
    var children = _ref11 /*:: */.children,
      node = _ref11 /*:: */.node;
    return /*#__PURE__*/_react.default.createElement(_Link.default, {
      title: node().title,
      url: node().url
    }, children());
  },
  list: function list(_ref12 /*:: */) {
    var children = _ref12 /*:: */.children,
      node = _ref12 /*:: */.node;
    return /*#__PURE__*/_react.default.createElement(_List.default, {
      ordered: node().ordered
    }, children());
  },
  listItem: function listItem(_ref13 /*:: */) {
    var children = _ref13 /*:: */.children;
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, null, children());
  },
  multipleSelectionView: function multipleSelectionView(_ref14 /*:: */) {
    var value = _ref14 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedList, {
      type: "conjunction",
      value: value
    });
  },
  numberView: function numberView(_ref15 /*:: */) {
    var node = _ref15 /*:: */.node,
      value = _ref15 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement("span", null, value.toLocaleString(undefined, node()));
  },
  paragraph: function paragraph(_ref16 /*:: */) {
    var children = _ref16 /*:: */.children;
    return /*#__PURE__*/_react.default.createElement(_BaseText.default, null, children());
  },
  groupView: function groupView(_ref17 /*:: */) {
    var value = _ref17 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_CodeSpan.default, null, JSON.stringify(value, null, 2));
  },
  referenceView: function referenceView(_ref18 /*:: */) {
    var value = _ref18 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_Link.default, {
      url: "/users/".concat(value)
    }, "@", value);
  },
  root: function root(_ref19 /*:: */) {
    var children = _ref19 /*:: */.children;
    return /*#__PURE__*/_react.default.createElement("div", null, children());
  },
  strong: function strong(_ref20 /*:: */) {
    var children = _ref20 /*:: */.children;
    return /*#__PURE__*/_react.default.createElement(_Embolden.default, null, children());
  },
  table: function table(_ref21 /*:: */) {
    var children = _ref21 /*:: */.children;
    return /*#__PURE__*/_react.default.createElement(_Table.default, null, children());
  },
  tableCell: function tableCell(_ref22 /*:: */) {
    var children = _ref22 /*:: */.children,
      node = _ref22 /*:: */.node;
    return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: node().align
    }, children());
  },
  tableRow: function tableRow(_ref23 /*:: */) {
    var children = _ref23 /*:: */.children;
    return /*#__PURE__*/_react.default.createElement(_TableRow.default, null, children());
  },
  text: function text(_ref24 /*:: */) {
    var value = _ref24 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement("span", null, value);
  },
  textAreaView: function textAreaView(_ref25 /*:: */) {
    var value = _ref25 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement("span", null, value);
  },
  textView: function textView(_ref26 /*:: */) {
    var value = _ref26 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement("span", null, value);
  },
  thematicBreak: function thematicBreak() {
    return /*#__PURE__*/_react.default.createElement(_Rule.default, null);
  },
  timeView: function timeView(_ref27 /*:: */) {
    var node = _ref27 /*:: */.node,
      value = _ref27 /*:: */.value;
    return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedTime, (0, _extends2.default)({}, node(), {
      value: Date.parse("1970-01-01T".concat(value))
    }));
  },
  toggleSwitchView: function toggleSwitchView(_ref28 /*:: */) {
    var value = _ref28 /*:: */.value;
    return typeof value !== 'undefined' ? /*#__PURE__*/_react.default.createElement("span", null, value.toString()) : null;
  }
} /*: any*/) /*: ViewMap*/);
var MarkdownViewContextValue = exports.MarkdownViewContextValue = {
  editor: VIEW_MAP,
  reader: VIEW_MAP
};
var Markdown = exports.Markdown = function Markdown(_ref29 /*:: */) {
  var context = _ref29 /*:: */.context,
    _ref29$sanitizeMarkdo = _ref29 /*:: */.sanitizeMarkdown,
    sanitizeMarkdown = _ref29$sanitizeMarkdo === void 0 ? true : _ref29$sanitizeMarkdo,
    _ref29$stripMarkdown = _ref29 /*:: */.stripMarkdown,
    stripMarkdown = _ref29$stripMarkdown === void 0 ? false : _ref29$stripMarkdown,
    value = _ref29 /*:: */.value,
    views = _ref29 /*:: */.views,
    map = _ref29 /*:: */.map;
  var getViews = (0, _react.useCallback)(function () {
    if (views || !context || (0, _typeof2.default)(context) !== 'object') {
      return;
    }
    return Object.entries(context).reduce(function (map, _ref30) {
      var _ref31 = (0, _slicedToArray2.default)(_ref30, 2),
        key = _ref31[0],
        value = _ref31[1];
      var reference = "/".concat(key);
      map["/".concat(key)] = _objectSpread(_objectSpread({}, (0, _viewUtilFromJsonCatalyticWeb.jsonToView)((value /*: any*/))), {}, {
        reference: reference
      });
      return map;
    }, ({} /*: ViewReferenceMap*/));
  }, [context, views]);
  var getNode = (0, _react.useCallback)(function () {
    return (0, _viewUtilFromMarkdown.viewFromMarkdown)(value || '', {
      sanitize: sanitizeMarkdown,
      strip: stripMarkdown,
      views: (getViews() /*: any*/)
    });
  }, [sanitizeMarkdown, stripMarkdown, getViews, value]);
  var getViewMap = (0, _react.useCallback)(function () {
    var viewMap = _objectSpread(_objectSpread({}, VIEW_MAP), map || {});
    return {
      editor: viewMap,
      reader: viewMap
    };
  }, [map]);
  return /*#__PURE__*/_react.default.createElement(_reactView.ViewContext.Provider, {
    value: getViewMap()
  }, /*#__PURE__*/_react.default.createElement(_reactView.View, {
    node: getNode(),
    value: context
  }));
};
Markdown.displayName = DISPLAY_NAME;
var _default = exports.default = Markdown;
//# sourceMappingURL=Markdown.js.map